import { openLink, openTelegramLink } from '@telegram-apps/sdk-react';

function tryParseUrl(url: string) {
  try {
    return new URL(url);
  } catch {
    return null;
  }
}

/**
 * Opens a link using the appropriate method based on the URL type.
 * For Telegram links (t.me), uses the Telegram SDK if available.
 * For other links, uses window.open.
 *
 * @param url - The URL to open
 */
export const openTelegramOrRegularLink = (urlString: string): void => {
  const url = tryParseUrl(urlString);

  const isTelegramLink = url?.hostname === 't.me';

  if (isTelegramLink && openTelegramLink.isAvailable()) {
    openTelegramLink(urlString);
    return;
  }

  if (openLink.isAvailable()) {
    openLink(urlString);

    return;
  }

  window.open(urlString, '_blank');
};
